import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CalanderFullService } from 'app/modules/Calander/services/calander-full.service';
import { DatosExcelReserva } from 'app/modules/common/entities/downloadexcel.model';
import { DownloadableDocument } from 'app/modules/common/entities/dropdown/downloadable-document.model';
import { DateFilterTypes } from 'app/modules/common/enums/date-filter-enums';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { TimeValidators } from 'app/modules/common/validators/time.validators';
import { SharedService } from 'app/modules/common/services/shared-service';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';

export type AddDownloadCalendarDialogParams = {
  medico: string;
  smeId: number;
  medicoId: number;
  empresaId: number;
  smeNombre: string;
  medicoPrincipalId?: number;
}; 

@Component({
    selector: 'app-download-calendar-dialog',
    templateUrl: './download-calendar-dialog.component.html',
    styleUrls: ['./download-calendar-dialog.component.scss'],
    standalone: false
})



export class DownloadCalendarDialogComponent implements OnInit {
  CalSelect: boolean = true;
  todoServicios: boolean = true;


  public form: UntypedFormGroup;
        constructor(@Inject(MAT_DIALOG_DATA) private data: AddDownloadCalendarDialogParams, private fb: UntypedFormBuilder, 
          private dialogRef: MatDialogRef<DownloadCalendarDialogComponent>,
          private pageLoader: PageLoaderService,
          private calendarfullservice: CalanderFullService,
          public fileExportService: FileExportService,
          private sharedService: SharedService ) 
          { }

  ngOnInit(): void {
    this.initForm();
    this.CalSelect = true;
    this.todoServicios = false;
    this.form.get('SoloPerfilSelect')?.valueChanges.subscribe((soloPerfil: boolean) => {
      if (!soloPerfil) {
        this.form.get('CalSelect')?.setValue(false);
      }
    });
  }


  private initForm() {
    this.form = this.fb.group(
        {
            smeId: 0,
            fecha: [null, Validators.required],
            hasta: [null, Validators.required],
            CalSelect:[true],
            todoServicios:[false],
            SoloPerfilSelect: [true],
        }
      );    
}

public onCancel() {
  this.dialogRef.close(false);
}

/**
* Save button click event handler
*/
public async onSave() {
  this.form.markAllAsTouched();

  // close dialog if form is valid and absent is created or updated
  if (this.form.valid) {
      this.pageLoader.ShowPageLoader();
      if (this.form.get('CalSelect').value) {
        var datosExcel : DatosExcelReserva = new DatosExcelReserva(this.data.smeId, this.data.smeNombre, DateHelper.getNativeDate(this.form.get('fecha').value),
        DateHelper.getNativeDate(this.form.get('hasta').value), this.data.medico, this.data.medicoId, this.data.empresaId, false );

        var soloPerfil = this.form.get('SoloPerfilSelect')?.value === true;
        (datosExcel as any).SoloPerfilSeleccionado = soloPerfil;
        (datosExcel as any).MedicoPrincipalId = this.data.medicoPrincipalId ?? null;

        this.calendarfullservice.downloadCalendar(datosExcel).subscribe(
          (data: any) => {
              if (data.code === 0) {
                const file = data.result as DownloadableDocument;
                this.fileExportService.DownloadDoc(file);
                this.pageLoader.HidePageLoader();
                this.dialogRef.close(false);

              }
          });
      }else{
        var datosExcelMultiple : DatosExcelReserva[] = [];
        this.sharedService.treeMedico.forEach(element => {
          datosExcelMultiple.push(new DatosExcelReserva(element.serviceId, element.text, DateHelper.getNativeDate(this.form.get('fecha').value),
            DateHelper.getNativeDate(this.form.get('hasta').value), this.data.medico, element.medicoId, element.empresaId, true ) );
            })

        const desde = DateHelper.getNativeDate(this.form.get('fecha')!.value);
        const hasta = DateHelper.getNativeDate(this.form.get('hasta')!.value);

      const soloPerfil = this.form.get('SoloPerfilSelect')?.value === true;
      const grupoActualId = this.data.medicoPrincipalId ?? this.data.medicoId;

      let nodosBase: any[] = [];

      if (soloPerfil) {
        nodosBase = (this.sharedService.treeMedico || [])
          .filter((e: any) =>
            e?.serviceId > 0 &&
            e?.medicoId > 0 &&
            e?.empresaId > 0
          );
      } else {
        nodosBase = (this.sharedService.treeMedicoAll || [])
          .filter((e: any) => {
            if (!(e?.serviceId > 0 && e?.medicoId > 0 && e?.empresaId > 0)) {
              return false;
            }

            const grupoNodoId = e.medicoPrincipalId ?? e.medicoId;
            return grupoNodoId === grupoActualId;
          });
      }

      

      nodosBase.forEach((e: any) => {
        const d: any = new DatosExcelReserva(
          e.serviceId,
          e.text,
          desde,
          hasta,
          this.data.medico,
          e.medicoId,
          e.empresaId, 
          true
        );

        d.SoloPerfilSeleccionado = soloPerfil;
        d.MedicoPrincipalId = e.medicoPrincipalId ?? null;

        datosExcelMultiple.push(d);

      });

      if (datosExcelMultiple.length === 0) {
        this.pageLoader.HidePageLoader();
        this.dialogRef.close(false);
        return;
      }

      this.calendarfullservice.downloadCalendarMultiple(datosExcelMultiple).subscribe(
        (data: any) => {
          if (data.code === 0) {
            const file = data.result as DownloadableDocument;
            this.fileExportService.DownloadDoc(file);
          }
          this.pageLoader.HidePageLoader();
          this.dialogRef.close(false);
        },
        () => {
          this.pageLoader.HidePageLoader();
          this.dialogRef.close(false);
        }
      );
  }
}

}
}